import { render, staticRenderFns } from "./OrderShipmentDelete.vue?vue&type=template&id=07ed7ca1&"
import script from "./OrderShipmentDelete.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07ed7ca1')) {
      api.createRecord('07ed7ca1', component.options)
    } else {
      api.reload('07ed7ca1', component.options)
    }
    module.hot.accept("./OrderShipmentDelete.vue?vue&type=template&id=07ed7ca1&", function () {
      api.rerender('07ed7ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDetail/OrderShipmentDelete.vue"
export default component.exports